import { ComponentProps } from 'react';

export function PhoneSupport({ ...props }: ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.975 12.0939L15.2484 15.2439C15.1464 15.6892 14.755 16.0008 14.2966 16.0008C6.4125 16.0002 0 9.58768 0 1.70331C0 1.24518 0.311531 0.853309 0.756875 0.751746L3.90687 0.025184C4.36562 -0.0811285 4.83437 0.156996 5.025 0.591434L6.47875 3.98206C6.64869 4.38143 6.53406 4.84675 6.19812 5.12112L4.51562 6.47206C5.5775 8.63518 7.33625 10.3939 9.5 11.4564L10.8775 9.77518C11.149 9.43831 11.6178 9.32175 12.0172 9.49472L15.4078 10.9482C15.8156 11.1627 16.0813 11.6377 15.975 12.0939Z"
        fill="currentColor"
      />
    </svg>
  );
}
